<template>
  <div  class="topbar" v-if="!this.$route.fullPath.includes('newdesigntest') && !isEmpty(user) && checkLocalForUserObject()">
    <BackButton class="back-button" />
    <h3 class="title">{{title}}</h3>
    <div class="menu-container">
      <el-menu
        class="topmenu"
        v-if="this.hidebottommenuonmobile"
        mode="horizontal"
        @select="handleSelect"
        :default-active="$route.name"
      >
        <el-menu-item index="DashboardAllProperties" class="menu-icon">
          <i class="fa-2x fas fa-home"></i>
        </el-menu-item>
        <el-menu-item index="DashboardAllProperties" class="menu-text">Dashboard</el-menu-item>

        <el-menu-item index="AllIssues" class="menu-icon">
          <i class="fa-2x fas fa-blender-phone"></i>
        </el-menu-item>
        <!-- <el-menu-item index="UsersAssets" class="menu-text">All Assets</el-menu-item> -->
        
         <el-menu-item index="AllIssues" class="menu-text">Work Orders</el-menu-item>

         <el-menu-item index="Inbox"  class="menu-text"> 
           <el-badge :value="unreadMsgsComputed" class="menu-text" style="max-height: 30px;">
             <p style="bottom: 31px; position: relative;"> Inbox </p>
            </el-badge>
         </el-menu-item>

          <el-menu-item index="Inbox" class="menu-icon">
            <el-badge style="top: 16px;" class="menu-icon" :value="unreadMsgsComputed">
        <i style="position: relative; bottom: 14px;" class="fa-2x fas fa-envelope"></i>
        </el-badge>

        </el-menu-item>
<!-- 
        <el-menu-item index="WorkOrderReports" class="menu-icon">
          <i class="el-icon-notebook-2"></i>
        </el-menu-item> -->
        <!-- <el-menu-item index="UsersAssets" class="menu-text">All Assets</el-menu-item> -->
        
         <el-menu-item index="WorkOrderReports" class="menu-text"> Reports </el-menu-item>

        <el-menu-item index="Feedback" class="menu-icon tst-main-menu-feedback-icon">
          <i class="fa-2x fas fa-comments"></i>
        </el-menu-item>
        <el-menu-item index="Feedback" class="menu-text  tst-main-menu-feedback-txt">Leave Feedback</el-menu-item>
      </el-menu>
    </div>
    <el-dropdown class="tst-usericon-menu avatarcontainer" @command="handleCommand" trigger="click">
      <el-button type="text">
        <img id="userImage" :src="this.user.imageurl" />
      </el-button>
      <el-dropdown-menu slot="dropdown">
        <el-dropdown-item class="tst-profile-menu-item" command="updateprofilehandler">Update Profile</el-dropdown-item>
        <el-dropdown-item class="tst-logout-menu-item" command="logoutcommandhandler">Log Out</el-dropdown-item>
        <el-dropdown-item command="routetoroles"> Your roles </el-dropdown-item>
      </el-dropdown-menu>
    </el-dropdown>
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
import BackButton from "@/components/utilities/BackButton.vue";
import EventService from "@/services/EventService.js";
import EventBus from '@/services/EventBus.js';

export default {
  components: {
    BackButton
  },
  data() {
    return {
      titletext: "JoBase title placeholder",
      unreadMsgsAmount: null,
      messagesArray: []
    };
  },
  computed: {
    ...mapActions(["changeprofilepicture"]),
    ...mapState({
      user: state => state.user.user,
      title: state => state.titlemessage.titletext
    }),
    screenwidth: function() {
      return document.documentElement.clientWidth;
    },
    hidebottommenuonmobile: function() {
      // this returns false if it's on a mobile screen and the route shows that's inside an issue, or in the tab2 where
      // the issues are usually viewed and an issue is not selected yet.
      if ((!this.$route.fullPath.includes("tab1") 
          && !this.$route.fullPath.includes("issue-"))  || this.screenwidth > 979) {
                return true;
      }
    },
    unreadMsgsComputed : function() {
      return this.unreadMsgsAmount > 0 ? this.unreadMsgsAmount : null
    }
 },
  created() {

    this.loggedIn(this.user);
 
    // if user object is empty - meaning the user is logged out - don't attempt to find image for userid which is undefined
    if(this.checkLocalForUserObject()){
        // fetch latest avatar
        EventService.getUserImage(this.user.userid).then(
          response => (this.user.imageurl = response.data.image)
        );
    }
  },
  methods: {
    ...mapActions(["loggedIn"]),
    ...mapActions(["logout"]),
    handleCommand(command) {
      if (command == "logoutcommandhandler") 
      {
        this.logUserOut();
      }
      if (command == "updateprofilehandler") 
      {
        this.$router.push({ name: "UpdateProfile" });
      }
      if(command == "routetoroles")
      {
        this.$router.push({ name: "Roles" });
      }
    },

    isEmpty(obj) {
      for (var key in obj) {
        if (obj.hasOwnProperty(key)) return false;
      }
      return true;
    },
    checkLocalForUserObject() {
      if (Object.keys(this.user).length > 0) {
        return true;
      } else {
        return false;
      }
    },
    logUserOut() {
      // this is the vuex logout function located in src/store/modules/user.js
      this.logout();
      this.$router.push({ name: "Login" });
    },
    UserNotValid() {
      this.logout();
    },
    handleSelect(key, keyPath) {
      console.log(key, keyPath);
      this.$router.push({ name: key });
    },
    handletextchange(data) {
      this.titletext = data;
    },
    getUnreadMsgsCount(){
       EventService.getUsersUnreadsAmount().then( response => {
             this.unreadMsgsAmount = response.data.inboxmessagecount;
      });

    }
  },
  mounted() {
      this.titletext = this.title;

      // if user object is empty - meaning the user is logged out - don't attempt to get msg count for userid which is undefined
      if(this.checkLocalForUserObject())
      {
          this.getUnreadMsgsCount();
      }
      EventBus.$on('user-logged-in', ($event) => {
        this.getUnreadMsgsCount();
      });
      
      EventBus.$on('inbox-message-dismissed', ($event) => {
          this.unreadMsgsAmount -= $event;
       });

  }
}
</script>

<style scoped>
.avatarcontainer {
  display: inline;
  float: right;
}
#userImage {
  height: 45px;
  max-height: 45px;
  width: 45px;
  max-width: 45px;
  border-radius: 50%;
  margin-right: 20px;
  margin-top: -5px;
}
.back-button {
  display: inline;
}

.title {
  color: rgb(89, 89, 89);
  display: inline;
  position: fixed;
  left: 75px;
  z-index: 4;
  max-width: 16vw;
  top: -5px;
  white-space:nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.topbar {
  top: 0;
  position: fixed;
  width: 100vw;
  z-index: 3;
  background-color: white;
  height: 60px;
}

.menu-container {
  position: fixed;
  display: inline;
}

.topmenu {
  display: flex;
  justify-content: center;
  padding: 0%;
}

@media (min-width: 980px) {
  .menu-icon {
    visibility: hidden;
    max-width: 0%;
    padding: 0%;
  }

  .menu-container {
    left: 10%;
    width: 80%;
  }
}

@media (min-width: 250px) and (max-width: 979px) {
  .topmenu {
    position: fixed;
    bottom: 0;
    width: 100%;
    left: 0;
  }

  .menu-text {
    visibility: hidden;
    max-width: 0%;
    padding: 0%;
  }

  .title {
    max-width: 45vw;
  }

}
</style>
